import React, { ComponentProps } from 'react';
import { ContentList, ContentListItem } from '../../_lib/components/ContentList';
import ILink from '../../types/ILink';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { ContentHeadline } from '../../_lib/components/ContentHeadline';
import { murmurhash } from '../../lib/js/hash';
import { ContentParagraph } from '../../_lib/components/ContentParagraph';
import { useSonTranslation } from '../../translation/useSonTranslation';

type RoleListItem = {
  roleName: string;
  editLink: ILink;
  description: string;
  forPageTypes: string[];
};

export type RolesListProps = {
  roles: RoleListItem[];
};

/**
 * Linked list of all role with name and description.
 */
function RolesList({ roles }: RolesListProps) {
  const { t } = useSonTranslation('RoleList');

  if (roles?.length === 0) {
    return null;
  }

  return (
    <ContentList ordered>
      {roles.map((roleItem) => {
        return (
          <ContentListItem key={roleItem.editLink.url}>
            <ContentHeadline
              title={roleItem.roleName}
              url={roleItem.editLink.url}
              hierarchy={2}
              modifier="top-headline"
              headingId={`role-list-heading-${murmurhash(roleItem.editLink.url)}`}
            />
            <ContentParagraph>{roleItem.description}</ContentParagraph>
            {roleItem.forPageTypes?.length > 0
              ? (
                  <ContentParagraph>
                    <dfn className="roles-list__dfn">{t('approvedFor')}:</dfn>{' '}
                    {roleItem.forPageTypes.map(pageType => t(`glossary:${pageType}` as any)).join(', ')}
                  </ContentParagraph>
                )
              : null}
          </ContentListItem>
        );
      })}
    </ContentList>
  );
}

export const RolesListBlock = asBlock(RolesList, BlockType.roleslist);
export type RolesListBlock = ComponentProps<typeof RolesListBlock>;
